<template>
  <el-scrollbar
    ref="scrollbar"
    wrap-class="custom_wrap_class"
    view-class="custom_view_class"
    :noresize="true"
  >
    <slot />
  </el-scrollbar>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    update() {
      this.$refs.scrollbar.update();
    },
    setScrollTopVal(val) {
      // console.error("=======this.$refs.scrollbar", this.$refs.scrollbar);
      this.$refs.scrollbar.setScrollTop(val);
    },
    setScrollTop(val, behavior = "smooth") {
      this.$refs.scrollbar.scrollTo({
        top: val,
        behavior,
      });
    },
    setScrollLeftVal(val) {
      this.$refs.scrollbar.scrollLeft(val);
    },
    setScrollLeft(val, behavior = "smooth") {
      this.$refs.scrollbar.scrollTo({
        left: val,
        behavior,
      });
    },
    isBottom() {
      const scrollTop = this.$refs.scrollbar.wrap$.scrollTop;
      const scrollHeight = this.$refs.scrollbar.wrap$.scrollHeight;
      const clientHeight = this.$refs.scrollbar.wrap$.clientHeight;
      if (scrollTop + clientHeight === scrollHeight) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.custom_wrap_class {
  /* padding-bottom: 17px; */
  height: 100%;
}

.custom_view_class {
  height: 100%;
}
</style>
<style scoped>
.el-scrollbar {
  width: 100%;
  height: 100%;
}
</style>
